export default {"src":"/_next/static/media/like.08f8ff4b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};